<section class="seo-service">
    <div class="container-fluid">
        <div class="row center-align">
            <div class="col-md-6">
                <div class="service">
                    <h2>
                        التسويق الالكتروني
                    </h2>
                    <p>
                        التسويق الالكتروني و الحملات الإعلانية الناجحة هي التي يحدد فيها الجمهور المستهدف بعناية، ثم تحدد أفضل السبل للوصول اليه خلال الفترة الزمنية المحددة للحملة.
                    </p>
                </div>
            </div>
            <div class="col-md-6 text-center">
                <img src="./../../../assets/images/mrkng-title.png" alt="seo" />
            </div>
        </div>
    </div>
</section>